import { FC, HTMLInputTypeAttribute, InputHTMLAttributes } from 'react';
import { Field } from 'formik';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  disabled?: boolean;
  value?: string;
  touched?: any;
  type?: HTMLInputTypeAttribute;
  name?: string;
  placeholder?: string;
  error?: string;
  // error?: Record<string, any>;
  label?: string;
  headText?: string;
  required?: boolean;
  children?: any;
}

const Select: FC<InputProps> = ({
  className,
  disabled,
  value,
  touched,
  type,
  name,
  placeholder,
  error,
  label,
  headText,
  children,
  ...rest
}) => (
  <div>
    {label && (
      <label className="text-white text-lg mb-2" htmlFor={name}>
        {label}
      </label>
    )}
    {headText && (
      <p className="text-white opacity-75 text-xs my-4">{headText}</p>
    )}
    <Field
      value={value}
      name={name}
      id={name}
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      className={`${
        touched && touched[name as string] && error
          ? 'border-red-500'
          : touched && touched[name as string] && ''
      } ${className} w-full`}
      {...rest}
      as="select"
    >
      {children}
    </Field>
    {error && touched && <p className="text-red-700 text-xs my-4">{error}</p>}
  </div>
);

export default Select;
